import { searchApi } from 'api/tenor';
import Gif from 'models/gif';

export const search = ({ q, pos }) =>
  searchApi({ q, pos }).then((res) => {
    const results = res.results.map((gifRes) => Gif.fromTenor(gifRes));
    const { next } = res;
    return { results, next };
  });
